import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { message } from "../../../Reducers/loading/actions";

import { Sendmail, Login, authError, confirmation2FA } from "../../../Reducers/auth/actions";

const LoginPage = ({ errorMessage, config, Login, Sendmail, authError, message, confirmation2FA }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    sendmail: false,
    sendmailluck: false,
  });
  const [attemptLogin, setAttemptLogin] = useState(false);
  const [rateLimited, setRateLimited] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [localMessage, setLocalMessage] = useState(null);
  const [show2FA, setShow2FA] = useState(false);
  const [twoFAToken, setTwoFAToken] = useState('');
  const [verificationCode, setVerificationCode] = useState('');

  const userLogin = async (e) => {
    e.preventDefault();
    
    // Reset rate limit state and local message
    setRateLimited(null);
    setLocalMessage(null);
    
    try {
      const result = await Login({
        email: credentials.email,
        password: credentials.password,
        strategy: "local",
      });
      
      if (result) {
        if (!result.check) {
          localStorage.setItem("token", result.token);
          message(1000, "success", "Het inloggen is gelukt");
          
          // Lokaal success message als fallback
          setLocalMessage({
            type: "success",
            text: "Het inloggen is gelukt! Je wordt doorverwezen..."
          });
          
          setTimeout(function () {
            window.location.replace("/");
          }, 500);
        }
        if (result.check === "blocked") {
          message(3000, "danger", "Je account je geblokkeerd");
          setLocalMessage({
            type: "danger",
            text: "Je account is geblokkeerd. Neem contact op met de beheerder."
          });
        }
        if (result.check === "sms") {
          navigate("/login/sms/" + result.token);
        }
        if (result.check === "email") {
          setCredentials({ ...credentials, sendmail: true });
          setLocalMessage({
            type: "warning",
            text: "Je e-mailadres is niet gecontroleerd. Controleer je mailbox."
          });
        }
        if (result.check === "ip_2fa") {
          setShow2FA(true);
          setTwoFAToken(result.token);
          setLocalMessage({
            type: "info",
            text: "Nieuw apparaat gedetecteerd. Een verificatiecode is naar je telefoon gestuurd. Voer deze hieronder in."
          });
        }
      }
    } catch (error) {
      
      // Check voor rate limiting error (429 status)
      if (error.status === 429 || (error.response && error.response.status === 429)) {
        const errorData = error.response || error;
        setRateLimited({
          message: errorData.message || "Te veel mislukte inlogpogingen",
          resetTime: errorData.blocked_until ? new Date(errorData.blocked_until) : null,
          retryAfter: errorData.retry_after || 3600,
          attemptsInfo: errorData.attempts_info
        });
        
        message(5000, "warning", errorData.message || "Te veel mislukte inlogpogingen. Probeer het later opnieuw.");
        
        // Fallback lokaal message
        setLocalMessage({
          type: "warning",
          text: errorData.message || "Te veel mislukte inlogpogingen. Probeer het later opnieuw."
        });
      } else {
        // Voor andere errors, gebruik de message uit de response of een standaard bericht
        const errorMessage = error.response?.message || 
                            error.response?.statusMessage || 
                            error.message || 
                            "Er is een fout opgetreden bij het inloggen";
        message(4000, "danger", errorMessage);
        
        // Fallback lokaal message
        setLocalMessage({
          type: "danger",
          text: errorMessage
        });
      }
    }
  };
  const sendvmail = async () => {
    const whatever = await Sendmail({ email: credentials.email });
    if (whatever) {
      setCredentials({ ...credentials, sendmail: false, sendmailluck: true });
    }
  };

  const verify2FA = async (e) => {
    e.preventDefault();

    if (!verificationCode.trim()) {
      setLocalMessage({
        type: "warning",
        text: "Voer een verificatiecode in."
      });
      return;
    }

    try {
      const result = await confirmation2FA({
        token: twoFAToken,
        verification_code: verificationCode
      });

      if (result && !result.check) {
        localStorage.setItem("token", result.token);
        message(1000, "success", "2FA verificatie succesvol - je bent ingelogd");

        setLocalMessage({
          type: "success",
          text: "2FA verificatie succesvol! Je wordt doorverwezen..."
        });

        setTimeout(function () {
          window.location.replace("/");
        }, 500);
      }
    } catch (error) {
      const errorMessage = error.response?.message || error.message || "Ongeldige verificatiecode";
      setLocalMessage({
        type: "danger",
        text: errorMessage
      });
    }
  };

  const onChange = (event) => {
    authError(null);
    const { name, value } = event.target;
    setCredentials({ ...credentials, [name]: value });
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    if (!code) {
      authError(null);
      return;
    }

    try {
      const bytes = CryptoJS.AES.decrypt(code, "882eh2h9e8hhe01ihe81tye01ihe98ye0");
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if (decryptedData.email && decryptedData.password) {
        setCredentials({
          ...credentials,
          email: decryptedData.email,
          password: decryptedData.password,
        });
      }
      setAttemptLogin(true); // Trigger poging om in te loggen
    } catch (err) {
      console.error("Fout bij decryptie of JSON-parsing:", err);
    }
  }, [location]); // Voeg location toe aan dependencies array

  useEffect(() => {
    // Probeer in te loggen als credentials zijn gezet
    if (attemptLogin) {
      userLogin({ preventDefault: () => {} });
      setAttemptLogin(false); // Reset de login trigger
    }
  }, [attemptLogin, credentials]); // Reageer op veranderingen in attemptLogin en credentials

  useEffect(() => {
    if (errorMessage) {
      message(5000, "danger", errorMessage);
    }
    if (credentials.sendmailluck) {
      message(5000, "info", "Er is een mail gestuurd om je account te activeren");
    }
  }, [errorMessage, credentials.sendmailluck]);

  // Rate limiting countdown effect
  useEffect(() => {
    let interval = null;
    
    if (rateLimited && rateLimited.retryAfter > 0) {
      setCountdown(rateLimited.retryAfter);
      
      interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown <= 1) {
            setRateLimited(null);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [rateLimited]);

  // Auto-clear local messages after 4 seconds
  useEffect(() => {
    if (localMessage) {
      const timer = setTimeout(() => {
        setLocalMessage(null);
      }, 4000);
      
      return () => clearTimeout(timer);
    }
  }, [localMessage]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    if (minutes > 0) {
      return `${minutes}m ${remainingSeconds}s`;
    }
    return `${remainingSeconds}s`;
  };

  const renderAlert = () => {
    // Rate limiting alert heeft prioriteit
    if (rateLimited) {
      return (
        <div className="alert alert-warning">
          <strong>Te veel inlogpogingen!</strong>
          <br />
          {rateLimited.message}
          {countdown > 0 && (
            <div className="mt-2">
              <strong>Probeer opnieuw over: {formatTime(countdown)}</strong>
            </div>
          )}
          {rateLimited.attemptsInfo && (
            <div className="mt-2 small">
              <div>IP pogingen: {rateLimited.attemptsInfo.ip_attempts}/4</div>
              {rateLimited.attemptsInfo.email_attempts > 0 && (
                <div>Email pogingen: {rateLimited.attemptsInfo.email_attempts}/4</div>
              )}
            </div>
          )}
        </div>
      );
    }

    // Lokaal message als fallback
    if (localMessage) {
      return (
        <div className={`alert alert-${localMessage.type}`}>
          <strong>{localMessage.type === 'danger' ? 'Fout!' : 'Let op!'}</strong>
          <br />
          {localMessage.text}
        </div>
      );
    }
    
    if (credentials.sendmail) {
      return (
        <div className="alert alert-danger">
          Je e-mailadres is niet gecontroleerd. Klik{" "}
          <strong className="pointer" onClick={sendvmail}>
            hier
          </strong>{" "}
          om nogmaals je account te activeren
          <br />
        </div>
      );
    }
  };

  return (
    <div className="login-box-body">
      <p className="login-box-msg">
        {show2FA ? "Voer je verificatiecode in" : "Vul je gegevens in om in te loggen"}
      </p>
      {renderAlert()}

      {!show2FA ? (
        <form method="post">
          <div className="form-group has-feedback">
            <input value={credentials.email} onChange={onChange} type="email" name="email" className="form-control" placeholder="E-mail adres" />
          </div>
          <div className="form-group has-feedback">
            <input value={credentials.password} onChange={onChange} type="password" name="password" className="form-control" placeholder="Wachtwoord" />
          </div>
          <div className=" form-group has-feedback row">
            <div className="col-xs-8"></div>
            {/* /.col */}
            <div className="col-xs-4">
              <button
                type="submit"
                onClick={(e) => userLogin(e)}
                className="loginbutton btn btn-primary btn-block btn-flat"
                disabled={rateLimited && countdown > 0}
              >
                {rateLimited && countdown > 0 ? (
                  <>Geblokkeerd ({formatTime(countdown)})</>
                ) : (
                  "Inloggen"
                )}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <form method="post">
          <div className="form-group has-feedback">
            <input
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, ''))}
              type="text"
              name="verification_code"
              className="form-control text-center"
              placeholder="000000"
              maxLength="6"
              autoComplete="one-time-code"
              style={{
                fontSize: '24px',
                letterSpacing: '8px',
                fontWeight: 'bold',
                height: '60px'
              }}
            />
            <i className="fa fa-shield form-control-feedback" style={{ marginTop: '10px' }}></i>
          </div>

          <div className="text-center mb-3">
            <small className="text-muted">
              <i className="fa fa-mobile"></i> Controleer je telefoon voor de verificatiecode
            </small>
          </div>

          <div style={{
            display: 'flex',
            gap: '10px',
            marginTop: '20px',
            width: '100%'
          }}>
            <button
              type="button"
              onClick={() => {
                setShow2FA(false);
                setTwoFAToken('');
                setVerificationCode('');
                setLocalMessage(null);
              }}
              className="btn btn-default btn-flat"
              style={{
                flex: '1',
                minWidth: '0'
              }}
            >
              <i className="fa fa-arrow-left"></i> Terug
            </button>
            <button
              type="submit"
              onClick={(e) => verify2FA(e)}
              className="btn btn-success btn-flat"
              disabled={!verificationCode.trim() || verificationCode.length < 6}
              style={{
                flex: '1',
                minWidth: '0'
              }}
            >
              <i className="fa fa-check"></i> Verifiëren
            </button>
          </div>

          <div className="text-center">
            <small className="text-muted">
              Code niet ontvangen? Wacht 60 seconden en probeer opnieuw in te loggen.
            </small>
          </div>
        </form>
      )}
      <div className="row">
        <div className="col-8">
          <Link to="/login/forget">Wachtwoord vergeten</Link>
        </div>
        {config.openregist && (
          <div className="col-4">
            <Link to="/login/forget">Maak Account</Link>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-12" style={{ marginTop: "10px" }}>
          <a href="/help" target="_blank" rel="noopener noreferrer">
            Hulp nodig? Bekijk de handleiding voor partner-organisaties
          </a>
        </div>
      </div>
      <br />
    </div>
  );
};

const mapStateToProps = (state) => ({
  errorMessage: state.auth.error,
  config: state.auth.config,
});

const mapDispatchToProps = {
  Sendmail,
  Login,
  authError,
  message,
  confirmation2FA,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
